import React, { useMemo } from "react";
import CommonFilterTable from "../../component/table/TableFiltter";
import { KEY, MODE_SCREEN } from "../../constants/common.const";
import { useMediaQuery } from "react-responsive";

function ListFacility({
  data = [],
  setCurrentData = () => {},
  currentData,
  mode,
  setFirstNodeFilter,
}) {
  const isPC = useMediaQuery({
      query: KEY.LAPTOP_WIDTH,
    })
  const initColumns = [
    {
      title: "No",
      dataIndex: "No",
      width: 80,
      align: "center",
      type: "number",
      render: (_, __, index) => {
        return <span>{_}</span>;
      },
    },

    {
      title: "施設名称",
      dataIndex: "facilityName",
      align: "left",
      width: 150,
    },

    {
      title: "処理区名称",
      dataIndex: "areaName",
      align: "left",
      width: 150,
    },
  ];

  return (
    <div style={{ height: "800px" }}>
      <CommonFilterTable
        setFirstNodeFilter={setFirstNodeFilter}
        color={"#fff"}
        className="table-selected-custom table-equipment-custome"
        onRow={(record) => {
          return {
            onClick: () => {
              if (mode !== MODE_SCREEN.VIEW) {
                return;
              }
              setCurrentData(record);
            },
          };
        }}
        rowKey={(record) => record.facilityCode}
        rowClassName={(record) =>
          currentData && record.facilityCode === currentData.facilityCode
            ? "selected-row-facilityMaster"
            : ""
        }
        data={ data.data}
        columns={initColumns}
        scrollY={`calc(100vh - ${isPC ? "420" : "520"}px)`}
        disabledFilter={mode !== MODE_SCREEN.VIEW}
        paging={true}
         tableKey="facilities"
         addedLeft={150}
      />
    </div>
  );
}

export default ListFacility;
